// New-feature glyphs. The design reference keeps Lucide-style strokes for
// constructs with no production counterpart (clipboard, sparkles, alert) while
// chrome icons stay Remix — see "Assets / Icons". These are inlined rather than
// pulled from a new dependency: three glyphs do not justify a package.

type IconProps = {
    size?: number;
    className?: string;
};

const base = (size: number) => ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none' as const,
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    focusable: false,
});

export const ClipboardIcon = ({ size = 17, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <rect x="8" y="2" width="8" height="4" rx="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <path d="M12 11h4" />
        <path d="M12 16h4" />
        <path d="M8 11h.01" />
        <path d="M8 16h.01" />
    </svg>
);

export const SparklesIcon = ({ size = 11, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
        <path d="M20 3v4" />
        <path d="M22 5h-4" />
    </svg>
);

export const AlertIcon = ({ size = 13, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4" />
        <path d="M12 16h.01" />
    </svg>
);

export const PencilIcon = ({ size = 13, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
        <path d="m15 5 4 4" />
    </svg>
);

export const ChevronLeftIcon = ({ size = 15, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <path d="m15 18-6-6 6-6" />
    </svg>
);

export const ChevronDownIcon = ({ size = 15, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <path d="m6 9 6 6 6-6" />
    </svg>
);

export const SearchIcon = ({ size = 14, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
    </svg>
);

export const CheckIcon = ({ size = 11, className }: IconProps) => (
    <svg {...base(size)} className={className}>
        <path d="M20 6 9 17l-5-5" />
    </svg>
);

export const CloseIcon = ({ size = 14, className }: IconProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        className={className}
    >
        <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95 1.414-1.414 4.95 4.95z" />
    </svg>
);
